import { Button, Col, Row, Space } from 'antd';
import React, { useState } from 'react';
import PlayVideoModal from '../video-modals/PlayVideoModal';

const IndividualVideo = ({
  title,
  description,
  publishDate,
  startTime,
  endTime,
  videoURL,
  thumbnailURL,
  course,
  subject,
  chapter,
  topic,
  setVideoURL,
  setFileName,
  setOpenVideoModal,
  setThumbnailURL,
}) => {
  const [playVideo, setPlayVideo] = useState(false);

  // Open video modal
  const openVideoModal = () => {
    setPlayVideo(true);
  };

  // Close video modal
  const closeVideoModal = () => {
    setPlayVideo(false);
  };

  // Handle video select
  const handleSelect = () => {
    setVideoURL(videoURL);
    setThumbnailURL(thumbnailURL);
    setFileName(title);
    setOpenVideoModal(false);
  };

  return (
    <>
      <Row className="border p-2">
        <Col span={8}>
          <p className="font-semibold text-medium mb-0">Title: {title}</p>
          <p className='mb-0'>Description: {description}</p>
          <p className='mb-0'>Chapter-{chapter.chapterNo}: {chapter.chapterName}</p>
        </Col>
        <Col span={8}>
          {publishDate && startTime && endTime ? (
            <div className="flex flex-col items-start justify-center gap-1">
              <span className="text-sm">
                {/* Publish on: {publishDate ? publishDate : 'N/A'} From: {startTime} To: {endTime} */}
                Publish on: {publishDate ? publishDate : 'N/A'}  Time: {startTime} - {endTime}

                {/* Subject: {subject.subjectName} */}
              </span>
              <span className="mb-0 text-sm">
                Course: {course.courseName}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Subject: {subject.subjectName}
                {/* publish on: {publishDate ? publishDate : 'N/A'} From: {startTime} To: {endTime} */}
              </span>
              <span className='mb-0'>Topic-{topic.topicNo}: {topic.topicName}</span>
            </div>
          ) : (
            <div>
              <p>Not yet scheduled</p>
            </div>
          )}
        </Col>

        <Col span={8} className="flex items-center justify-end gap-2">
          <Button onClick={openVideoModal} size="small" type="primary" className="px-5 h-9">
            Watch Video
          </Button>
          <Button onClick={handleSelect} size="small" type="primary" className="px-5 h-9">
            Select
          </Button>
        </Col>
      </Row>
      <PlayVideoModal videoURL={videoURL} playVideo={playVideo} closeVideoModal={closeVideoModal} />
    </>
  );
};

export default IndividualVideo;
